import { render, staticRenderFns } from "./FooterNew.vue?vue&type=template&id=6060fa5e&scoped=true"
import script from "./FooterNew.vue?vue&type=script&lang=js"
export * from "./FooterNew.vue?vue&type=script&lang=js"
import style0 from "./FooterNew.vue?vue&type=style&index=0&id=6060fa5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6060fa5e",
  null
  
)

export default component.exports